// extracted by mini-css-extract-plugin
export var label = "label-module--label--a0470";
export var labelDark = "label-module--label--dark--b3376";
export var labelDisabled = "label-module--label--disabled--db9bc";
export var label__display = "label-module--label__display--92914";
export var label__tooltipIcon = "label-module--label__tooltip-icon--b4c35";
export var label__tooltipIconDark = "label-module--label__tooltip-icon--dark--098c8";
export var mt0 = "label-module--mt-0--4c6ae";
export var mt1 = "label-module--mt-1--5a952";
export var mt2 = "label-module--mt-2--27948";
export var mt3 = "label-module--mt-3--1e2fc";
export var mt4 = "label-module--mt-4--bb707";
export var mt5 = "label-module--mt-5--c8f58";
export var mt6 = "label-module--mt-6--8e220";
export var wrapper = "label-module--wrapper--f813a";